import React from 'react';

import { Container } from 'react-bootstrap';
import FancyR from '../../components/FancyR/FancyR'

import PropTypes from 'prop-types';

import styles from './Success.module.css';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';


class Success extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      years: 0,
      pledgeOnly: this.props.pledgeOnly
    };
  }

  componentDidMount = () => this.setState({ years: this.props.years || 0 });

  renderSuccess = type => {
    switch (type) {
      case 'homeowner':
        return this.renderHomeownerRenter();
      case 'renter':
        return this.renderHomeownerRenter();
      case 'business':
        return this.renderBusinessEvent();
      case 'other':
        return this.renderBusinessEvent();
      default:
        return this.renderHomeownerRenter();
    }
  }

  renderHomeownerRenter = () => {
    return (
      <section>
        <h3 className='text-center'>
          {this.state.pledgeOnly ?
            <>
              <strong>
                <p>
                  Thank you for joining the Reciprocity revolution. Together, we are building a community that is working to make Indigenous land, language and rights more visible, and recognition more real. We are not yet operational in your area, but we will reach out as soon as we get things up and running!
                </p>
              </strong>
            </>
            :
            <>
              <strong>
                <p>
                  Thank you for joining the Reciprocity revolution. Together, we are building a community that is working to make Indigenous land, language and rights more visible, and recognition more real. You are now starting a new tradition of more meaningfully saying thank you for the beautiful Indigenous lands where we are privileged to live, work and play.
                </p>
              </strong>
              <p className='font-thin'>
                We’ll be in touch via email with your receipt, as well as to confirm the mailing address for your reciprocity swag so that you can show off your new <FancyR text="home" /> certification.
              </p>
            </>
          }
        </h3>
      </section>
    )
  }

  renderBusinessEvent = () => {
    return (
      <section>
        <h3 className='text-center'>
          <>
            <strong>
              <p>
                Thanks for your interest in joining the Reciprocity revolution. Together, we are building a community that is working to make Indigenous land, language and rights more visible, and recognition more real. We’ve received your info and will be in touch soon to discuss your unique business or event.
              </p>
            </strong>
          </>
        </h3>
      </section>
    )
  }

  render() {
    return (
      <Container className={styles.container}>
        <section className='text-center'>
          <h1 className='marginBottom25'>
            <span className='reciprocityGreenText'>Congratulations!</span>
          </h1>
        </section>

        {this.renderSuccess(this.props.type)}

        <section className='text-center'>
          <div className='m-auto pt-3'>
            <a className='mx-2' target='_blank' rel='noopener noreferrer' href="https://www.facebook.com/reciprocitytrusts">
              <FacebookIcon className="footer-social-media" />
            </a>
            <a className='mx-2' target='_blank' rel='noopener noreferrer' href="https://x.com/reciprocity_ca">
              <XIcon className="footer-social-media" />
            </a>
            <a className='mx-2' target='_blank' rel='noopener noreferrer' href="https://www.instagram.com/reciprocitytrusts/">
              <InstagramIcon className="footer-social-media" />
            </a>
            <a className='mx-2' target='_blank' rel='noopener noreferrer' href="https://www.youtube.com/@ReciprocityTrusts">
              <YouTubeIcon className="footer-social-media" />
            </a>
            <a className='mx-2' target='_blank' rel='noopener noreferrer' href="mailto:hello@reciprocityconnects.ca">
              <MailIcon className="footer-social-media" />
            </a>
            <a className='mx-2' target='_blank' rel='noopener noreferrer' href="tel:778-606-2511">
              <PhoneIcon className="footer-social-media" />
            </a>
          </div>
          <p className='text-muted pt-3'>Thank you for joining our Reciprocity revolution.</p>
          <p className='text-muted pb-3'>Want to talk? Give us a call at <a href='tel:778-606-2511;ext=1'>778.606.2511 ext. 1</a>.</p>
          {/* <Button variant='light' href='/account' className={styles.dashboardButton}>Go to your account</Button> */}
        </section>
      </Container>
    )
  }
}

Success.propTypes = {
  type: PropTypes.string.isRequired,
  years: PropTypes.number
};

export default Success;
